var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteFade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3118 5.35417L12.7336 13.4492C12.6837 14.1469 12.1031 14.6875 11.4036 14.6875H5.88659C5.18707 14.6875 4.60649 14.1469 4.55665 13.4492L3.97843 5.35417M7.31177 8.02083V12.0208M9.97843 8.02083V12.0208M10.6451 5.35417V3.35417C10.6451 2.98598 10.3466 2.6875 9.97843 2.6875H7.31177C6.94358 2.6875 6.6451 2.98598 6.6451 3.35417V5.35417M3.31177 5.35417H13.9784",
    stroke: "#9DA3AE",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteFade);
export default __webpack_public_path__ + "static/media/DeleteFade.a1d2eb3508f25427564eeeac77bca272.svg";
export { ForwardRef as ReactComponent };